// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Documentos · Plataforma (backoffice): comparte tarjetas, campos y botones de
   fila con la cola de payouts (PlataformaPagos.css). Lo propio es la búsqueda
   por folio, el motivo, la razón y el resultado de la anulación.
   Tokens del design system; sin hex sueltos. */

.pld-search {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin: 8px 0 20px;
}
.pld-search__field,
.pld-reason {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
}
.pld-search__field input,
.pld-reason textarea {
  font-family: var(--mono);
  font-size: var(--fs-2xs);
  padding: 6px 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius-0);
  background: var(--bg);
  color: var(--text);
}
.pld-search__field input {
  width: 160px;
}
.pld-search__field input[aria-invalid='true'] {
  border-color: var(--err);
}

/* Mismo aire que la línea bajo el encabezado de la tarjeta (.plp-card__fields):
   12px sobre la línea y bajo ella. */
.pld-annul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: var(--space-3);
  padding: 12px 0 4px;
  border-top: 1px solid var(--border);
}
.pld-motivo {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  margin: 0;
  padding: 0;
  border: 0;
}
.pld-motivo legend {
  float: left;
  margin-right: 4px;
}
.pld-motivo__opt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-2xs);
  color: var(--text);
}

.pld-result {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px 0 4px;
}
.pld-outcome {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  font-size: var(--fs-2xs);
  color: var(--text-secondary);
}
.pld-corrections {
  margin: 0;
  padding-left: 18px;
}
.pld-execute {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
}
.pld-reason {
  flex: 1 1 280px;
}
.pld-reason textarea {
  width: 100%;
  resize: vertical;
}

/* Las notas de crédito de la factura, desde la búsqueda (REC-1957). */
.pld-notes {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: var(--space-3);
}
`, "",{"version":3,"sources":["webpack://./src/pages/plataforma/PlataformaDocumentos.css"],"names":[],"mappings":"AAAA;;;+CAG+C;;AAE/C;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;;AAEA;qCACqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0BAA0B;AAC5B","sourcesContent":["/* Documentos · Plataforma (backoffice): comparte tarjetas, campos y botones de\n   fila con la cola de payouts (PlataformaPagos.css). Lo propio es la búsqueda\n   por folio, el motivo, la razón y el resultado de la anulación.\n   Tokens del design system; sin hex sueltos. */\n\n.pld-search {\n  display: flex;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin: 8px 0 20px;\n}\n.pld-search__field,\n.pld-reason {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.pld-search__field input,\n.pld-reason textarea {\n  font-family: var(--mono);\n  font-size: var(--fs-2xs);\n  padding: 6px 8px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-0);\n  background: var(--bg);\n  color: var(--text);\n}\n.pld-search__field input {\n  width: 160px;\n}\n.pld-search__field input[aria-invalid='true'] {\n  border-color: var(--err);\n}\n\n/* Mismo aire que la línea bajo el encabezado de la tarjeta (.plp-card__fields):\n   12px sobre la línea y bajo ella. */\n.pld-annul {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: var(--space-3);\n  padding: 12px 0 4px;\n  border-top: 1px solid var(--border);\n}\n.pld-motivo {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n.pld-motivo legend {\n  float: left;\n  margin-right: 4px;\n}\n.pld-motivo__opt {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--fs-2xs);\n  color: var(--text);\n}\n\n.pld-result {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 14px 0 4px;\n}\n.pld-outcome {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  font-size: var(--fs-2xs);\n  color: var(--text-secondary);\n}\n.pld-corrections {\n  margin: 0;\n  padding-left: 18px;\n}\n.pld-execute {\n  display: flex;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n.pld-reason {\n  flex: 1 1 280px;\n}\n.pld-reason textarea {\n  width: 100%;\n  resize: vertical;\n}\n\n/* Las notas de crédito de la factura, desde la búsqueda (REC-1957). */\n.pld-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: var(--space-3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
